import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function AuthLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar */}
      <Navbar />

      {/* Page Content */}
      <div className="flex-1">
        <Outlet />   {/* LoginPage will handle its own full-screen layout */}
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
